import * as htmlToImage from 'html-to-image';
import { elementToSVG } from 'dom-to-svg';

const modes = {
  standard: 'Standard',
  scenarios: 'Szenarienvergleich',
  time: 'Zeitvergleich',
  warmingstripes: 'Warming Stripes',
  years: 'Jahresvergleich',
};

const isSiteInDarkMod = () => {
  const el = document.querySelector('html[data-theme]');
  if (el) {
    const { theme } = el.dataset;

    if (theme) {
      return theme === 'dark' ? 1 : 0;
    }
  }
  return 0;
};

const generateFileName = (configString) => {
  const epochString = configString.includes('param[epoch]=future')
    ? 'Zukunft'
    : 'Vergangenheit';

  const visTypeString = configString.includes('param[vistype]=map')
    ? 'Kartendarstellung'
    : 'Zeitverlauf';

  const mode = configString.match('(?<=param\\[mode\\]\\=)(.*?)(?=\\&)')[0];
  const modeString = modes[mode];
  return `BayKIS_${epochString}_${modeString}_${visTypeString}`;
};

export const exportImage = {
  toPNG: (node, callbackFn) => {
    const options = {
      pixelRatio: 1,
    };
    setTimeout(() => {
      htmlToImage.toBlob(node, options).then((blob) => {
        window.saveAs(blob, 'chart.png');

        callbackFn && callbackFn();
      });
    }, 100);
  },
  toPNGNew: (node, callbackFn, configString, apiUrl) => {
    setTimeout(() => {
      const download = (url, name) => {
        if (!url) {
          console.log('error downloading png');
        }

        fetch(url)
          .then((response) => response.blob())
          .then((blob) => {
            const blobURL = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobURL;
            a.style = 'display: none';

            if (name && name.length) a.download = name;
            document.body.appendChild(a);
            a.click();
            callbackFn && callbackFn();
          })
          .catch(() => console.log('error downloading png'));
      };
      const darkModeParam = `dark_mode=${isSiteInDarkMod()}`;
      const endpointUrl = `${apiUrl.replace(
        'api/',
        'image/'
      )}download?${configString}&usp=download&selector=.download-container&file_extension=png&${darkModeParam}`;
      fetch(endpointUrl)
        .then((response) => response.json())
        .then((response) => {
          console.log(`response: ${response.url}`);
          const secureUrl = response.url.replace('http', 'https');
          download(secureUrl, 'chart.png');
        });
    }, 100);
  },
  toPDF: (node, callbackFn, configString, apiUrl) => {
    setTimeout(() => {
      const download = (url, name) => {
        if (!url) {
          console.log('error downloading pdf');
        }

        fetch(url)
          .then((response) => response.blob())
          .then((blob) => {
            const blobURL = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobURL;
            a.style = 'display: none';

            if (name && name.length) a.download = name;
            document.body.appendChild(a);
            a.click();
            callbackFn && callbackFn();
          })
          .catch(() => console.log('error downloading pdf'));
      };
      const darkModeParam = `dark_mode=${isSiteInDarkMod()}`;
      const endpointUrl = `${apiUrl.replace(
        'api/',
        'image/'
      )}download?${configString}&usp=pdf&selector=.download-container&file_extension=pdf&${darkModeParam}`;
      fetch(endpointUrl)
        .then((response) => response.json())
        .then((response) => {
          const secureUrl = response.url.replace('http', 'https');
          download(secureUrl, `${generateFileName(configString)}.pdf`);
        });
    }, 100);
  },
  toSVG: (node, callbackFn) => {
    setTimeout(() => {
      const svgDocument = elementToSVG(node);
      const html = new XMLSerializer().serializeToString(svgDocument);
      const svgBlob = new Blob([html], { type: 'image/svg+xml' });
      saveAs(svgBlob, 'chart.svg');

      callbackFn && callbackFn();
    }, 100);
  },
  toSVGLegacy: (node, callbackFn) => {
    setTimeout(() => {
      htmlToImage.toSvg(node).then((dataURL) => {
        const dl = document.createElement('a');
        document.body.appendChild(dl);
        dl.setAttribute('href', dataURL);
        dl.setAttribute('download', 'chart.svg');
        dl.click();
      });
      callbackFn && callbackFn();
    }, 100);
  },
};

export default {};
